const isBusImageSkip = ({ busTransportationCompanyCode, imageSrc }) => {
  if (imageSrc) return true
  return !busTransportationCompanyCode
}

export default isBusImageSkip
